import script from "./SubmitPhotosPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SubmitPhotosPage.vue?vue&type=script&setup=true&lang=js"

import "./SubmitPhotosPage.vue?vue&type=style&index=0&id=0739d3da&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/claims-portal/claims-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0739d3da"]])

export default __exports__